import React from 'react';
import PropTypes from 'prop-types';
import YoutubeEmbed from 'react-youtube';

import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import { Table } from 'semantic-ui-react';

const youtubeEmbedOpts = {
  color: 'white',
  width: '100%',
  showinfo: 1,
};

const NewInfluencerTabModal = ({
  onClose,
  onDontShowAgain,
}) => (
  <DyzioModal
    onClose={onClose}
    size="large"
    hasActionButton
    actionButtonContent="don't show this message again"
    headerText="The Influencer tab has changed!"
    onActionButtonClick={onDontShowAgain}
  >
    <Table>
      <Table.Body>
        <Table.Row>
          <Table.Cell width={8}>
            <YoutubeEmbed videoId="US8HPFi6zOQ" opts={youtubeEmbedOpts} />
          </Table.Cell>
          <Table.Cell width={8}>
            <p>
        Hello, we have changed the way the Influencer tab works... We no longer display the Influencer posts
        on this tab directly. You now have to click on the influencer&apos;s card to view or add posts.
            </p>
            <br />
            <p>
        This change will make the Influencer tab faster to load for large campaigns and also
        allow us to add more functionality to the new Influencer page. If you have any questions or
        comments please contact us using the chat button in the bottom right of your screen.
            </p>
            <br />
            <p>
              All the funcionality that was on the Influencer card such as Add Post, Send Invitation etc
              is now found on the new Influencer page.
            </p>
            <br />
            <p>Click the button below to dismiss this window permanently.</p>
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  </DyzioModal>
);

NewInfluencerTabModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDontShowAgain: PropTypes.func.isRequired,
};

export default NewInfluencerTabModal;



/** WEBPACK FOOTER **
 ** ./src/components/new-influencer-tab-modal/index.js
 **/